export default __webpack_public_path__ + "static/mcv-11291b049cb9a38abcf38db0c6e4cbcb.png";